import { render, staticRenderFns } from "./Objectif.vue?vue&type=template&id=b0f347f8&scoped=true"
import script from "./Objectif.vue?vue&type=script&lang=js"
export * from "./Objectif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f347f8",
  null
  
)

export default component.exports